import { SET_COMPANIES } from "./companiesConstants";
import { throwErrorMessage } from "../../lib/error_helper";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";

function setCompaniesAction(companies) {
    return {
        type: SET_COMPANIES,
        companies: companies,
    };
}

export function getCompanies(user, onSuccess) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout("/api/v1/companies/get_companies/" + user.id, {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((companies) => {
                dispatch(setCompaniesAction(companies));

                if (typeof onSuccess === "function") onSuccess(companies);
            })
            .catch((err) => {
                console.error("Erreur : companiesActions - getCompanies", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des agences",
                    })
                );
            });
    };
}
